import {
    AutoStories,
    Calculate,
    ContactPage,
    DateRange,
    Description,
    DisabledByDefault,
    Factory,
    House,
    ImportContacts,
    MenuBook,
    Payments,
    Receipt,
    ReceiptLong,
    Reorder,
    RequestPage,
    RequestQuote,
    List,
    Addchart,
    Dataset,
    Grading,
    AccountCircle,
} from "@mui/icons-material";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import Usinas from "./modal/usinas";
import { CardButton } from "./styles";
import { Container } from "../../../theme/globalStyles";
import Credito from "./modal/credito";
import FaturaInstalacao from "./modal/faturaConcessionarias";
import FaturaPublicadas from "./modal/faturaPublicadas";
import MovimentacoesUcs from "./modal/movimentacoesUcs";
import FaturasCliente from "./modal/faturasCliente";
import FaturasPendentes from "./modal/faturasPendentes";
import HistoricoConsumo from "./modal/historicoConsumo";
import InstalacoesCanceladas from "./modal/instalacoesCanceladas";
import ListRelatorios from "./listaRelatorios";
import ModalGeral from "./modal/geral";
import MovimentacaoClientes from "./modal/movimentacaoClientes";
import ConsolidadoProvisao from "./modal/consolidadoProvisao";
import FormasFaturamento from "./modal/formasFaturamento";
import React from "react";
import Refaturamento from "./modal/refaturamento";
import DeducaoAcrescimo from "./modal/deducaoEacrescimo";
import StatusUsinas from "./modal/statusUsinas";
import GeracaoUsinas from "./modal/geracaoUsinas";
import FaturasChurn from "./modal/faturasChurn";
import { useAuth } from "../../../context/global";
import ResumoFaturamento from "./modal/resumoFaturamento";
import ParametrosRebate from "./modal/parametrosRebate";
import CalculoRebate from "./modal/calculoRebate";
import Bonificacao from "./modal/bonificacao";
import serviceInstalacao from "@/services/serviceInstalacao";
import IGenericResult from "@/interfaces/IGenericResult";
import Parametro from "./modal/parametro";
import ConsolidacaoCliente from "./modal/consolidacaoCliente";
import FaturamentoGerencial from "./modal/faturamentoGerencial";

const GerarRelatorios: React.FC = () => {
    const { setTitlePage } = useAuth();
    const [modalId, setModalId] = useState(0);
    const [instalacaoDataOptions, setInstalacaoDataOptions] = useState<IGenericResult[]>([]);
    const { handleGetDataUser } = useAuth();
    const user = handleGetDataUser();

    useEffect(() => {
        setInstalacaoData();
        setTitlePage("Relatórios - Gerar relatórios");
    }, [setTitlePage]);

    const setInstalacaoData = async () => {
        serviceInstalacao
            .getInstalacoes()
            .then((result) => {
                setInstalacaoDataOptions(result?.data);
            })
            .catch(() => {
                setInstalacaoDataOptions([]);
            });
    };

    const handleRenderIcon = (icon: string) => {
        switch (icon) {
            case "description":
                return <Description />;
            case "house":
                return <House />;
            case "contactPage":
                return <ContactPage />;
            case "menuBook":
                return <MenuBook />;
            case "calculate":
                return <Calculate />;
            case "autoStories":
                return <AutoStories />;
            case "disabled":
                return <DisabledByDefault />;
            case "factory":
                return <Factory />;
            case "importContacts":
                return <ImportContacts />;
            case "receipt":
                return <Receipt />;
            case "receiptLong":
                return <ReceiptLong />;
            case "requestPage":
                return <RequestPage />;
            case "dateRange":
                return <DateRange />;
            case "payments":
                return <Payments />;
            case "database":
                return <Reorder />;
            case "requestQuote":
                return <RequestQuote />;
            case "list":
                return <List />;
            case "chart":
                return <Addchart />;
            case "dataset":
                return <Dataset />;
            case "grading":
                return <Grading />;
            case "accountCircle":
                return <AccountCircle />;
            default:
                return <House />;
        }
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2, mt: "40px" }}>
                        <Grid container spacing={3}>
                            {ListRelatorios.map((item, index) => {
                                return (
                                    item.permissions &&
                                    user &&
                                    user?.perfil &&
                                    item.permissions.includes(user?.perfil.toLowerCase()) && (
                                        <Grid item md={3} xs={12} key={index}>
                                            <CardButton onClick={() => setModalId(item.id)}>
                                                {handleRenderIcon(item.icon)}
                                                <Typography variant="subtitle1">{item.title}</Typography>
                                            </CardButton>
                                        </Grid>
                                    )
                                );
                            })}
                        </Grid>
                    </Box>
                </CardContent>
            </Card>

            {modalId === 1 && (
                <ModalGeral open onClose={() => setModalId(0)} instalacaoOptions={instalacaoDataOptions} />
            )}
            {modalId === 2 && <FaturaInstalacao open onClose={() => setModalId(0)} />}
            {modalId === 3 && <StatusUsinas open onClose={() => setModalId(0)} />}
            {modalId === 4 && <InstalacoesCanceladas open onClose={() => setModalId(0)} />}
            {modalId === 5 && <HistoricoConsumo open onClose={() => setModalId(0)} />}
            {modalId === 6 && <ConsolidadoProvisao open onClose={() => setModalId(0)} />}
            {modalId === 7 && <MovimentacaoClientes open onClose={() => setModalId(0)} />}
            {modalId === 8 && <FaturaPublicadas open onClose={() => setModalId(0)} />}
            {modalId === 9 && <FaturasPendentes open onClose={() => setModalId(0)} />}
            {modalId === 10 && <FormasFaturamento open onClose={() => setModalId(0)} />}
            {modalId === 11 && <FaturasCliente open onClose={() => setModalId(0)} />}
            {modalId === 12 && <MovimentacoesUcs open onClose={() => setModalId(0)} />}
            {modalId === 13 && <GeracaoUsinas open onClose={() => setModalId(0)} />}
            {modalId === 14 && <Usinas open onClose={() => setModalId(0)} />}
            {modalId === 15 && <Credito open onClose={() => setModalId(0)} />}
            {modalId === 16 && <Refaturamento open onClose={() => setModalId(0)} />}
            {modalId === 17 && <DeducaoAcrescimo open onClose={() => setModalId(0)} />}
            {modalId === 18 && <FaturasChurn open onClose={() => setModalId(0)} />}
            {modalId === 19 && <ResumoFaturamento open onClose={() => setModalId(0)} />}
            {modalId === 20 && <ParametrosRebate open onClose={() => setModalId(0)} />}
            {modalId === 21 && <CalculoRebate open onClose={() => setModalId(0)} />}
            {modalId === 22 && <Bonificacao open onClose={() => setModalId(0)} />}
            {modalId === 23 && <Parametro open onClose={() => setModalId(0)} />}
            {modalId === 24 && <ConsolidacaoCliente open onClose={() => setModalId(0)} />}
            {modalId === 25 && <FaturamentoGerencial open onClose={() => setModalId(0)} />}
        </Container>
    );
};

export default GerarRelatorios;
